export default __webpack_public_path__ + "e7747a127fc05babf2c79d1d1e1ed047.png";